import React, { useState } from 'react';

import UrlFormInput from '../components/UrlFormInput';
import UrlFormResult from '../components/UrlFormResult';

const ShortenUrlForm = () => {

  const [inputUrl, setInputUrl] = useState('');
  const [afterUrl, setAfterUrl] = useState('');

  // 短縮をリセットする
  const handleProcessUrl = (getUrl,dataId) => {
    setInputUrl(getUrl);
    setAfterUrl(dataId);
  };

  // 短縮をリセットする
  const handleinputUrl = () => {   
    setInputUrl('');   
  };

  return (
    <div>
      {!inputUrl && <UrlFormInput onProcess={handleProcessUrl} />}
      {inputUrl && <UrlFormResult inputUrl={inputUrl} afterUrl={afterUrl} onMoreProcess={handleinputUrl} />}
    </div>
  );
};

export default ShortenUrlForm;